module.exports = __webpack_public_path__ + "static/nudge-c9f3a066b5a5e2c1fa09c58fd0db31b6.png";